import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

// ==========================================
// CONFIGURATION: UPDATE YOUR DETAILS HERE
// ==========================================
// Format: Country Code + Phone Number (No '+' symbol, no spaces)
// Example: For India (+91) number 9876543210, use "919876543210"
const WHATSAPP_NUMBER = "919810042051"; 

const DEFAULT_MESSAGE = "Hi, I'm interested in manufacturing supplements with BuildMySupplement.";
// ==========================================

const WhatsAppWidget: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Show widget after a small delay for better UX
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
      setShowTooltip(true);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Hide tooltip after 10 seconds automatically
  useEffect(() => {
    if (showTooltip) {
      const timer = setTimeout(() => setShowTooltip(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [showTooltip]);

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end pointer-events-none">
      
      {/* Tooltip / Call to action */}
      <div 
        className={`pointer-events-auto mb-4 mr-2 bg-white px-4 py-3 rounded-2xl shadow-xl border border-gray-100 flex items-center gap-3 transition-all duration-500 origin-bottom-right ${
          showTooltip ? 'opacity-100 scale-100 translate-y-0' : 'opacity-0 scale-90 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="flex flex-col">
           <span className="font-bold text-gray-900 text-sm">Get a free quote?</span>
           <span className="text-xs text-gray-500">Chat with our experts</span>
        </div>
        <button 
            onClick={() => setShowTooltip(false)}
            className="text-gray-500 hover:text-gray-700 p-1"
            aria-label="Close tooltip"
        >
            <X size={14} />
        </button>
      </div>

      {/* Button Container */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with us on WhatsApp"
        className="pointer-events-auto group relative flex items-center justify-center w-16 h-16 bg-[#25D366] rounded-full shadow-lg hover:shadow-green-500/40 hover:-translate-y-1 transition-all duration-300"
        onMouseEnter={() => setShowTooltip(true)}
      >
        {/* Pulse Effect */}
        <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-20 animate-ping"></span>
        
        {/* WhatsApp Icon SVG */}
        <svg 
            viewBox="0 0 24 24" 
            className="w-8 h-8 text-white fill-current"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppWidget;